module.exports = __webpack_public_path__ + "static/media/productDividing1.e579055e.png";